import { tns } from "tiny-slider";
window.addEventListener("DOMContentLoaded", () => {
  const heroSlider = document.querySelector('#hero-slider')
  if(heroSlider) {
    var hero_slider = tns({
      container: heroSlider,
      items: 1,
      slideBy: '1',
      autoplay: false,
      nav: false,
      controlsContainer: '#hero-controls',
      prevButton: '#hero-previous',
      nextButton: '#hero-next',
      // gutter:24
    });
  }
})